import type { CreateFusionConfig } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { FusionConfigDto } from './use-fusion-configs.js';

interface CreateFusionConfigInput {
  clientId: string;
  body: CreateFusionConfig;
}

/** Mutation for `POST /v1/clients/{clientId}/fusion-configs`. */
export function useCreateFusionConfigMutation(): UseMutationResult<
  FusionConfigDto,
  Error,
  CreateFusionConfigInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, body }: CreateFusionConfigInput) => {
      if (!api) throw new Error('useCreateFusionConfigMutation: api client unavailable');
      return api.post<FusionConfigDto>(`/v1/clients/${clientId}/fusion-configs`, body);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['fusion-configs', clientId] });
    },
  });
}
